module.exports = __webpack_public_path__ + "images/kyotolease80bbf34c4587d52263959ed390d3dae1.png";